// Local enum mirror — previously imported from the shared lead-api package.

export enum EmploymentIndustry {
  AdministrationOffice = "ADMINISTRATION_OFFICE",
  AgricultureForestry = "AGRICULTURE_FORESTRY",
  AirTransportation = "AIR_TRANSPORTATION",
  Automotive = "AUTOMOTIVE",
  Chemistry = "CHEMISTRY",
  Construction = "CONSTRUCTION",
  Culture = "CULTURE",
  CustomsMaritimeTransport = "CUSTOMS_MARITIME_TRANSPORT",
  DebtCollection = "DEBT_COLLECTION",
  Education = "EDUCATION",
  EducationResearch = "EDUCATION_RESEARCH",
  Engineering = "ENGINEERING",
  FinanceAccounting = "FINANCE_ACCOUNTING",
  FinancialServices = "FINANCIAL_SERVICES",
  FoodEntertainment = "FOOD_ENTERTAINMENT",
  ForestryWood = "FORESTRY_WOOD",
  GovernmentPublicService = "GOVERNMENT_PUBLIC_SERVICE",
  Healthcare = "HEALTHCARE",
  HealthcareSocialServices = "HEALTHCARE_SOCIAL_SERVICES",
  HotelsAndTourism = "HOTELS_AND_TOURISM",
  ItSoftware = "IT_SOFTWARE",
  ManufacturingProductionConstruction = "MANUFACTURING_PRODUCTION_CONSTRUCTION",
  Media = "MEDIA",
  MetalProduction = "METAL_PRODUCTION",
  Military = "MILITARY",
  Mining = "MINING",
  NailHairCare = "NAIL_HAIR_CARE",
  OilAndGas = "OIL_AND_GAS",
  Other = "OTHER",
  Police = "POLICE",
  PostAndTelecommunicationsService = "POST_AND_TELECOMMUNICATIONS_SERVICE",
  ProfessionalServices = "PROFESSIONAL_SERVICES",
  RealEstate = "REAL_ESTATE",
  SalesMarketingCustomerServices = "SALES_MARKETING_CUSTOMER_SERVICES",
  Textiles = "TEXTILES",
  Tobacco = "TOBACCO",
  Trade = "TRADE",
  TransportationLogistics = "TRANSPORTATION_LOGISTICS",
}

export enum EmploymentOccupation {
  BlueCollar = "BLUE_COLLAR",
  BusinessOwner = "BUSINESS_OWNER",
  BusinessProcessOutsourcing = "BUSINESS_PROCESS_OUTSOURCING",
  Driver = "DRIVER",
  Employed = "EMPLOYED",
  Farmer = "FARMER",
  ForeignResident = "FOREIGN_RESIDENT",
  Freelancer = "FREELANCER",
  Housewife = "HOUSEWIFE",
  Journalist = "JOURNALIST",
  Lawyer = "LAWYER",
  MilitaryPersonnel = "MILITARY_PERSONNEL",
  Official = "OFFICIAL",
  Other = "OTHER",
  OverseasWorker = "OVERSEAS_WORKER",
  Police = "POLICE",
  PrivateSector = "PRIVATE_SECTOR",
  PublicSector = "PUBLIC_SECTOR",
  Retired = "RETIRED",
  Salaried = "SALARIED",
  SelfEmployed = "SELF_EMPLOYED",
  Student = "STUDENT",
  TemporaryEmployed = "TEMPORARY_EMPLOYED",
  Unemployed = "UNEMPLOYED",
  WhiteCollar = "WHITE_COLLAR",
}

export enum LoanPurpose {
  BusinessExpenses = "BUSINESS_EXPENSES",
  CreditCard = "CREDIT_CARD",
  EducationExpenses = "EDUCATION_EXPENSES",
  ElectronicsPurchase = "ELECTRONICS_PURCHASE",
  EmergencyOrUnexpectedExpenses = "EMERGENCY_OR_UNEXPECTED_EXPENSES",
  EstablishingCreditHistory = "ESTABLISHING_CREDIT_HISTORY",
  GroceriesAndDailyExpenses = "GROCERIES_AND_DAILY_EXPENSES",
  HomeMaintenanceAndImprovement = "HOME_MAINTENANCE_AND_IMPROVEMENT",
  LoanPaymentOrConsolidation = "LOAN_PAYMENT_OR_CONSOLIDATION",
  MajorPurchase = "MAJOR_PURCHASE",
  MedicalExpenses = "MEDICAL_EXPENSES",
  Other = "OTHER",
  PaymentForServices = "PAYMENT_FOR_SERVICES",
  RelocationExpenses = "RELOCATION_EXPENSES",
  SpecialEvent = "SPECIAL_EVENT",
  Travel = "TRAVEL",
  VehiclePurchase = "VEHICLE_PURCHASE",
  VehicleRepairOrPurchase = "VEHICLE_REPAIR_OR_PURCHASE",
}

export enum ProductType {
  CreditCard = "CREDIT_CARD",
  DepartmentCard = "DEPARTMENT_CARD",
  /** @deprecated use lineOfBusiness together with SelectedProductInput */
  EWallet = "E_WALLET",
  Insurance = "INSURANCE",
  MandatoryCarInsurance = "MANDATORY_CAR_INSURANCE",
  MotorbikeInsurance = "MOTORBIKE_INSURANCE",
  NearPrime = "NEAR_PRIME",
  Other = "OTHER",
  Securities = "SECURITIES",
  SubPrime = "SUB_PRIME",
  TravelInsurance = "TRAVEL_INSURANCE",
}

export enum SalaryCycle {
  Biweekly = "BIWEEKLY",
  Monthly = "MONTHLY",
  SemiMonthly = "SEMI_MONTHLY",
  Weekly = "WEEKLY",
}
